
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/githubactions/thanks",
      function () {
        return require("private-next-pages/services/githubactions/thanks.tsx");
      }
    ]);
  